import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import handleObject from '@/src/utils/handle-objects'
import store from '@state/store'
import jwt_decode from "jwt-decode"

let _moment = require('moment')

let serverUrl = getSecret('SERVER_MASTER_URL')
let serverFormsUrl = getSecret('SERVER_FORMS_URL')

export const state = {
}

export const getters = {
 
}

export const mutations = {
 
}

export const actions = {
 setFamilies(context, data){
    let promise = null
    promise = axios.post(`${serverFormsUrl}/api/families/`, data, {
      headers: { 'accept': 'application/json' },
    })
    return promise.then((response) => {
      return response.data
    })
 },
 getFamiliesBySearch(context, data){
  let promise = null
  let search = encodeURIComponent(data.codigoFamilia ? data.codigoFamilia : data.direccion)
  promise = axios.get(`${serverFormsUrl}/api/families/?search=${search}` , {
    headers: { 'accept': 'application/json' },
  })
  return promise.then((response) => {
    return response.data
  })
 },
 getFamiliesByAdd(context, data){
  let promise = null
  let direccion = encodeURIComponent(data.direccion)
  promise = axios.get(`${serverFormsUrl}/api/families/?direccion__icontains=${direccion}` , {
    headers: { 'accept': 'application/json' },
  })
  return promise.then((response) => {
    return response.data
  })
 },
 getFamiliesByCode(context, data){
  let promise = null
  let codigoFamilia = encodeURIComponent(data.codigoFamilia)
  promise = axios.get(`${serverFormsUrl}/api/families/?codigoFamilia=${codigoFamilia}`, {
    headers: { 'accept': 'application/json' },
  })
  return promise.then((response) => {
    return response.data
  })
 },
 getFamiliesByPersonId(context, data){
  let promise = null
  promise = axios.get(`${serverFormsUrl}/api/families/?personas__id=${data.PersonId}`, {
    headers: { 'accept': 'application/json' },
  })
  return promise.then((response) => {
    return response.data
  })
 }
}
